import { Box, Button, Checkbox, DialogActions, DialogContent, DialogTitle, Drawer, FormControl, FormLabel, Grid, Input, ModalClose, Option, Select, Textarea } from "@mui/joy";
import React from "react";
import { Util } from "../Helpers/Util";
import { Elevator } from "../Interfaces/Elevator";
import { DatePicker } from "@mui/x-date-pickers";

interface ElevatorDialogProps {
	elevatorsId: string;
	close: Function;
	buildingsId: string;
}

export default function ElevatorDialog(props: ElevatorDialogProps) {
	const [elevator, setElevator] = React.useState<Elevator>();
	const [open, setOpen] = React.useState(false);

	React.useEffect(() => {
		if (!Util.isNullOrEmpty(props.elevatorsId)) {
			fetch("Building/GetElevatorData", {
				method: "Post",
				headers: {
					"Content-Type": "application/json",
				},
				cache: "no-cache",
				body: JSON.stringify({ elevatorsId: props.elevatorsId }),
			})
				.then((x) => x.json())
				.then((x) => {
					// setNote(x as NotesRecord);
					console.log(x);
					const e = x[0] as Elevator;
					e.inspection_expiration_date = Util.ParseDate(x[0].inspection_expiration_date);
					setElevator(e);
					setOpen(true);
				});
		} else {
			setElevator({} as Elevator);
			setOpen(true);
		}
	}, []);

	const save = () => {
		if (!elevator) return;
		elevator.buildings_id = props.buildingsId;
		fetch("Building/SaveElevatorData", {
			method: "Post",
			headers: {
				"Content-Type": "application/json",
			},
			cache: "no-cache",
			body: JSON.stringify({ elevatorData: elevator }),
		}).then((x) => close());
	};

	const close = () => {
		props.close();
	};

	const sizes = {
		sm: 12,
		md: 6,
	};

	const threeSizes = {
		sm: 12,
		md: 6,
		lg: 4,
	};
	return (
		<>
			<Drawer anchor="right" open={open} size="lg">
				<ModalClose onClick={close} />
				<DialogTitle>Elevator Form</DialogTitle>
				<DialogContent sx={{ padding: 2 }}>
					{elevator && (
						<Grid container spacing={2} sx={{ overflowX: "hidden" }}>
							<Grid xs={12}>
								<FormLabel sx={{ typography: "title-md", fontWeight: "bold" }}>Elevator Information</FormLabel>
							</Grid>
							<Grid {...threeSizes}>
								<FormControl>
									<FormLabel>Serial Number</FormLabel>
									<Input
										value={elevator.serial_number}
										onChange={(event) => {
											setElevator({ ...elevator, serial_number: event.target.value });
										}}></Input>
								</FormControl>
							</Grid>
							<Grid {...threeSizes}>
								<FormControl>
									<FormLabel>Description</FormLabel>
									<Input
										value={elevator.description}
										onChange={(event) => {
											setElevator({ ...elevator, description: event.target.value });
										}}></Input>
								</FormControl>
							</Grid>
							<Grid {...threeSizes}>
								<FormControl>
									<FormLabel>Type</FormLabel>
									<Select value={elevator.type} onChange={(event, value) => setElevator({ ...elevator, type: value as string })}>
										<Option value="Hydraulic">Hydraulic</Option>
										<Option value="Wheelchair">Wheelchair</Option>
										<Option value="Traction">Traction</Option>
									</Select>
								</FormControl>
							</Grid>

							<Grid {...threeSizes}>
								<FormControl>
									<FormLabel>Track Maintenance</FormLabel>
									<Checkbox checked={elevator.track_maintenance} onChange={(event) => setElevator({ ...elevator, track_maintenance: event.target.checked })} />
								</FormControl>
							</Grid>
							<Grid {...threeSizes}>
								<FormControl>
									<FormLabel>Days Since Last Maint.</FormLabel>
									<Input value={elevator.days_since_last_maintenance} disabled></Input>
								</FormControl>
							</Grid>

							<Grid {...threeSizes}>
								<FormControl>
									<FormLabel>Out of Service?</FormLabel>
									<Checkbox checked={elevator.out_of_service} onChange={(event) => setElevator({ ...elevator, out_of_service: event.target.checked })} />
								</FormControl>
							</Grid>
							<Grid {...threeSizes}>
								<FormControl>
									<FormLabel>Inspection Expiration Date</FormLabel>
									<DatePicker
										slotProps={{
											textField: { variant: "standard", size: "small" },
										}}
										value={elevator.inspection_expiration_date}
										format="MM/dd/yyyy"
										onChange={(value) => {
											setElevator({ ...elevator, inspection_expiration_date: value as Date });
										}}
									/>
								</FormControl>
							</Grid>
							<Grid xs={12}>
								<FormLabel sx={{ typography: "title-md", fontWeight: "bold" }}>Address</FormLabel>
							</Grid>
							<Grid {...threeSizes}>
								<FormControl>
									<FormLabel>Street Address 1</FormLabel>
									<Input
										value={elevator.address1}
										onChange={(event) => {
											setElevator({ ...elevator, address1: event.target.value });
										}}></Input>
								</FormControl>
							</Grid>
							<Grid {...threeSizes}>
								<FormControl>
									<FormLabel>Street Address 2</FormLabel>
									<Input
										value={elevator.address2}
										onChange={(event) => {
											setElevator({ ...elevator, address2: event.target.value });
										}}></Input>
								</FormControl>
							</Grid>
							<Grid {...threeSizes}>
								<FormControl>
									<FormLabel>City</FormLabel>
									<Input
										value={elevator.city}
										onChange={(event) => {
											setElevator({ ...elevator, city: event.target.value });
										}}></Input>
								</FormControl>
							</Grid>
							<Grid {...threeSizes}>
								<FormControl>
									<FormLabel>State</FormLabel>
									<Input
										value={elevator.state}
										onChange={(event) => {
											setElevator({ ...elevator, state: event.target.value });
										}}></Input>
								</FormControl>
							</Grid>
							<Grid {...threeSizes}>
								<FormControl>
									<FormLabel>Zip</FormLabel>
									<Input
										value={elevator.zip}
										onChange={(event) => {
											setElevator({ ...elevator, zip: event.target.value });
										}}></Input>
								</FormControl>
							</Grid>
						</Grid>
					)}
				</DialogContent>
				<DialogActions>
					<Box sx={{ padding: 2 }}>
						<Button size="lg" color="primary" onClick={save} sx={{ mx: 1 }}>
							Save
						</Button>
						<Button size="lg" color="primary" onClick={close} sx={{ mx: 1 }}>
							Close
						</Button>
					</Box>
				</DialogActions>
			</Drawer>
		</>
	);
}
